import {useState, useEffect} from 'react';

const useLoadAnimation = (url) => {
  const [animation, setAnimation] = useState(null);

  useEffect(() => {
    async function getData() {
      try {
        const response = await fetch(url);

        const json = await response.json();
        setAnimation(json);
      } catch (error) {
        console.error(error.message);
        setAnimation(null);
      }
    }

    getData();

    return () => setAnimation(null);
  }, []);

  const isLoaded = !!animation;

  return {isLoaded, animation};
};

export default useLoadAnimation;
